// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/","redirect":"/home","parentId":"@@/global-layout","id":"1"},"2":{"path":"/login","layout":false,"id":"2"},"3":{"path":"/promptTest","parentId":"@@/global-layout","id":"3"},"4":{"path":"/home","parentId":"@@/global-layout","id":"4"},"5":{"path":"/user-record","parentId":"@@/global-layout","id":"5"},"6":{"path":"/image-history","parentId":"@@/global-layout","id":"6"},"7":{"path":"/sku","parentId":"@@/global-layout","id":"7"},"8":{"path":"/generate-video","parentId":"@@/global-layout","id":"8"},"9":{"path":"/generate-image","parentId":"@@/global-layout","id":"9"},"@@/global-layout":{"id":"@@/global-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__Login__index" */'@/pages/Login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__PromptTest__index" */'@/pages/PromptTest/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__Home__index" */'@/pages/Home/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__User__Record__index" */'@/pages/User/Record/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__User__ImageHistory__index" */'@/pages/User/ImageHistory/index.tsx')),
'7': React.lazy(() => import(/* webpackChunkName: "p__SKU__index" */'@/pages/SKU/index.tsx')),
'8': React.lazy(() => import(/* webpackChunkName: "p__GenerateVideo__index" */'@/pages/GenerateVideo/index.tsx')),
'9': React.lazy(() => import(/* webpackChunkName: "p__GenerateImage__index" */'@/pages/GenerateImage/index.tsx')),
'@@/global-layout': React.lazy(() => import(/* webpackChunkName: "layouts__index" */'/Users/craig/workspace/vastx-web/src/layouts/index.tsx')),
},
  };
}
